var Form = {
	init: function () {
		this.sendForm();

		$("input.opacity-filled").blur(function(){
			if( !$(this).val()){
				$(this).removeClass("filled");
			}else{
				$(this).addClass("filled");
			}
		});

	},
	sendForm: function(){
		$('.form-ajax').each(function (i, elt) {
			$(elt).on('submit', function(ev){

				ev.preventDefault();
				var formData = new FormData(this);

				$.ajax({
					url: ajaxurl,
					type: 'POST',
					data: formData,
					success: function (data) {
						var _data = JSON.parse(data);
						$(".form-response .text").html(_data.message);
						window.scrollTo(0, 0);
						$(".formulaire-container").addClass("hidden");
						$(".form-response").addClass("displayed");
						$(".illus-right").removeClass("hidden");
						$(".rejoindre-container").addClass("response");
						$(".img-1").removeClass("hidden");
						$(".img-2").addClass("hidden");

						setTimeout(function () {
							$(".form-response").addClass("visible");
						}, 40);

					},
					cache: false,
					contentType: false,
					processData: false
				});

			});
		});
	},
};
$(window).load(function(){
	if($(".form-ajax").length){
		Form.init();
	}
});